import { useState, useEffect } from 'react';
import dayjs from 'dayjs';

export const useMifSelection = (caseDetails, activeRequest) => {
  const [mif, setMIF] = useState([]);
  const [mifMetadata, setMIFMetadata] = useState({ createdAt: null, type: null });

  useEffect(() => {
    if (!caseDetails || !activeRequest) return;

    const requests = (Array.isArray(caseDetails.requests)
        ? caseDetails.requests 
        : [
          {
            requestType: 'initial',
            parsedMIF: caseDetails.parsedMIF,
            createdAt: caseDetails.createdDate
          },
          ...caseDetails.rxRenewalRequests || []
        ]
      )
      // fix for strange bug where MIF not on request in .requests but _is_ in the corresponding .rxRenewalRequests
      .map(request => {
        if (request.requestType === 'initial') {
          if (!request.parsedMIF?.length) {
            request.parsedMIF = caseDetails.parsedMIF
          }
        }
        else if (request.requestType === 'rx renewal') {
          if (!request.parsedMIF) {
            const matchingRenewalRequest = caseDetails.rxRenewalRequests.find(renewal => {
              return dayjs(renewal.createdAt).format('YYYY-MM-DD') === dayjs(request.createdAt).format('YYYY-MM-DD');
            })

            if (matchingRenewalRequest.parsedMIF) {
              request.parsedMIF = matchingRenewalRequest.parsedMIF
            }
          }
        }

        return request;
      })
      .reverse();

    const activeRequestIndex = requests
      .map(request => request._id?.toString())
      .indexOf(activeRequest?._id?.toString());


    const latestRequestWithMIF = requests
      .slice(activeRequestIndex)
      .find(request => !!request.parsedMIF?.length);

    setMIF(latestRequestWithMIF?.parsedMIF);
    setMIFMetadata({
      createdAt: latestRequestWithMIF?.createdAt,
      type: latestRequestWithMIF?.requestType
    });
  }, [caseDetails, activeRequest]);

  return [mif, mifMetadata];
};